<div fxLayout="column" fxLayoutGap="16px">

  <ng-container *ngIf="jobStatus.status === JobStatus.IN_PROGRESS || jobStatus.status === JobStatus.WAITING">
    <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <mat-spinner mode="indeterminate" color="accent" diameter="64" strokeWidth="5"></mat-spinner>
      <span>{{ 'MASSIVE_COMPANY_DIALOG.WAITING_IMPORT' | translate }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.ERROR">
    <h2>{{ 'MASSIVE_COMPANY_DIALOG.ERROR.ERROR' | translate }}</h2>

    <ul fxFlex>
      <li *ngFor="let error of jobStatus.errors">
        <span>{{ error }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.COMPLETED">
    <div fxLayout="column" fxLayoutGap="24px">
      <div *ngIf="hasMainCompany" fxLayout="column" fxLayoutGap="16px">
        <div class="mat-h2">{{ jobStatus?.output?.mainCompany?.companyType | titlecase }}</div>

        <mat-table [dataSource]="mainCompany" class="import-table">
          <!-- businessName Column -->
          <ng-container matColumnDef="businessName">
            <mat-header-cell *matHeaderCellDef fxFlex="2 1 0">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.BUSINESS_NAME' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="2 1 0">
              <span class="text-truncate" [matTooltip]="element.businessName">{{ element.businessName }}</span>
            </mat-cell>
          </ng-container>

          <!-- taxCode Column -->
          <ng-container matColumnDef="taxCode">
            <mat-header-cell *matHeaderCellDef fxFlex>
              <span>{{ 'MASSIVE_COMPANY_DIALOG.TAX_CODE' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex>
              <span>{{ element.taxCodePrefix }} {{ element.taxCode }}</span>
            </mat-cell>
          </ng-container>

          <!-- foundOnCribis Column -->
          <ng-container matColumnDef="foundOnCribis">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.CRIBIS' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.CRIBIS' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.foundOnCribis">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existing Column -->
          <ng-container matColumnDef="existing">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.COMPANY' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.COMPANY' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.existing">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existingByRole Column -->
          <ng-container matColumnDef="existingByRole">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.ROLE' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.ROLE' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.existingByRole">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existingRelationship Column -->
          <ng-container matColumnDef="existingRelationship">
            <mat-header-cell *matHeaderCellDef fxFlex="100px"></mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px"></mat-cell>
          </ng-container>

          <!-- Row -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>

      <div *ngIf="relatedCompanies" fxLayout="column" fxLayoutGap="16px">

        <div class="mat-h2">{{ getRelatedCompaniesTableTitle() }}</div>

        <mat-table [dataSource]="relatedCompanies" class="import-table">
          <!-- businessName Column -->
          <ng-container matColumnDef="businessName">
            <mat-header-cell *matHeaderCellDef fxFlex="2 1 0">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.BUSINESS_NAME' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="2 1 0">
              <span class="text-truncate" [matTooltip]="element.businessName">{{ element.businessName }}</span>
            </mat-cell>
          </ng-container>

          <!-- taxCode Column -->
          <ng-container matColumnDef="taxCode">
            <mat-header-cell *matHeaderCellDef fxFlex>
              <span>{{ 'MASSIVE_COMPANY_DIALOG.TAX_CODE' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex>
              <span>{{ element.taxCodePrefix }} {{ element.taxCode }}</span>
            </mat-cell>
          </ng-container>

          <!-- foundOnCribis Column -->
          <ng-container matColumnDef="foundOnCribis">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.CRIBIS' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.CRIBIS' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.foundOnCribis">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existing Column -->
          <ng-container matColumnDef="existing">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.COMPANY' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.COMPANY' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.existing">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existingByRole Column -->
          <ng-container matColumnDef="existingByRole">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.ROLE' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.ROLE' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.existingByRole">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- existingRelationship Column -->
          <ng-container matColumnDef="existingRelationship">
            <mat-header-cell *matHeaderCellDef fxFlex="100px" fxLayoutAlign="center center">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.LINK' | translate }}</span>
              <mat-icon
                class="icon-16 ml-4"
                [matTooltip]="'MASSIVE_COMPANY_DIALOG.INFO_TOOLTIP.LINK' | translate"
                matTooltipPosition="above">
                info
              </mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxFlex="100px" fxLayoutAlign="center center">
              <ng-container *ngIf="element.existingRelationship">
                <mat-icon>check</mat-icon>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- Row -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
    </div>
  </ng-container>

</div>
